import {
  FETCH_HOME_PAGE_WIDGET,
  SET_HOME_PAGE_WIDGET,
  UPDATE_HOME_PAGE_WIDGET,
} from "./actionTypes";

const homePageWidget = {
  widgets: {},
};

export const actions = {
  fetchHomePageWidget: () => ({
    type: FETCH_HOME_PAGE_WIDGET,
  }),
  setHomePageWidget: (payload) => ({
    type: SET_HOME_PAGE_WIDGET,
    payload,
  }),
  updateHomePageWidget: (payload) => ({
    type: UPDATE_HOME_PAGE_WIDGET,
    payload,
  }),
};

function reducer(state = homePageWidget, action) {
  switch (action.type) {
    case SET_HOME_PAGE_WIDGET: {
      return {
        widgets: action.payload,
      };
    }
    case UPDATE_HOME_PAGE_WIDGET: {
      return {
        widgets: {
          ...state.widgets,
          ...action.payload,
        },
      };
    }

    default:
      return state;
  }
}

reducer.initialState = homePageWidget;

export default reducer;
